import { StepImpl } from './step-impl';
import { CongratulationsRouteName } from '../constants';

export class CongratulationStep extends StepImpl {
  isHidden = true;
  constructor() {
    super(CongratulationsRouteName, CongratulationsRouteName);
  }
}
